import { useTranslation } from 'component/translation';
import { Stack } from 'expo-router';
import { editorialDashModuleQuery, useModule } from 'system/structure-modules';
import { t } from 'util/stdtypes';

export default function EditorialDashboardNewSpaceScreen() {
    const { NewSpaceScreen } = useModule(editorialDashModuleQuery);
    const title = useTranslation(t('spaces.new_space_title', 'New space'));
    return (
        <>
            <Stack.Screen options={{ title }} />
            <NewSpaceScreen />
        </>
    );
}
